import { EMPTY_FIELD } from 'constants/emptyField';

import { RaRecord } from 'react-admin';
import { Typography, TypographyProps } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { formatCurrency } from 'utils';

type Props = {
  source: string;
  currencyAlphaCode?: string;
} & Pick<TypographyProps, 'fontWeight'>;

export const CurrencyAmountField: React.FC<Props> = ({
  source,
  currencyAlphaCode,
  fontWeight = 500,
}) => {
  return (
    <FunctionField
      render={(record: RaRecord) => {
        if (!record?.[source]) {
          return EMPTY_FIELD;
        }
        return (
          <Typography fontWeight={fontWeight} variant="body2">
            {formatCurrency(record?.[source], currencyAlphaCode)}
          </Typography>
        );
      }}
    />
  );
};
